import {createState} from './stateFns';

let __instance__;

class StateStorage {
    constructor(opts) {
        /**
         * State Storage
         * @type {array}
         * @private
         */
        Object.defineProperty(this, '__storage__', {
            value: [createState()],
            writable: false,
            configurable: false,
            enumerable: false
        });

        /**
         * Options
         * @type {{maxHistoryState: number}}
         * @private
         */
        Object.defineProperty(this, '__opts__', {
            value: Object.assign({
                maxHistoryState: 10
            }, opts),
            writable: false,
            configurable: false,
            enumerable: false
        });
    }

    /**
     * Get StateStorage instance
     * @param [opts] {object}
     * @returns {StateStorage}
     */
    static getInstance(opts) {
        if (!(__instance__ instanceof StateStorage))
            return (__instance__ = new StateStorage(opts));

        return __instance__;
    }

    /**
     * Get option
     * @param key {string}
     * @returns {*}
     */
    getOption(key) {
        return this.__opts__[key];
    }

    /**
     * Set option and return it
     *
     * @param key {string}
     * @param value {*}
     *
     * @returns {*}
     */
    setOption(key, value) {
        return (this.__opts__[key] = value);
    }

    /**
     * Merge current options with another object
     * @param newOpts {object}
     * @returns {boolean}
     */
    mergeOptions(newOpts) {
        if (typeof newOpts !== 'object')
            throw new TypeError('`newOpts` argument must be of type object!');

        this.__opts__ = Object.assign(this.__opts__, newOpts);
        return true;
    }

    /**
     * Get internal storage
     * @returns {array}
     */
    getStorage() {
        return this.__storage__;
    }

    /**
     * Get a state by index from storage
     * @param i
     * @returns {Immutable.map}
     */
    getStateByIndex(i) {
        return this.getStorage()[i];
    }

    /**
     * Get previous state (index: 1)
     * @returns {Immutable.map}
     */
    getPrevState() {
        return this.getStateByIndex(1);
    }

    /**
     * Get current state (index: 0)
     * @returns {Immutable.map}
     */
    getCurrState() {
        return this.getStateByIndex(0);
    }

    /**
     * Update storage with new state
     * @param id {string}
     * @param state {Immutable.map}
     */
    updateStorage(id, state) {
        const maxHistory  = this.getOption('maxHistoryState');
        const storage     = this.getStorage();
        const currState   = storage[0];
        const len         = storage.length;

        if (len >= maxHistory)
            storage.pop();

        storage.unshift(currState.set(id, state));
    }
}

export default StateStorage;